import React from "react";
import { waLink } from "../config";
import { WhatsAppIcon } from "../components/WhatsAppButton";

const CLOTHES = [["S", "34-36", "82-86", "62-66", "88-92"], ["M", "38-40", "88-92", "68-72", "94-98"], ["L", "42-44", "94-98", "74-78", "100-104"], ["XL", "46-48", "100-104", "80-84", "106-110"]];
const BRA = [["85A / 90A", "78-83", "Bonnet A"], ["85B / 90B", "83-88", "Bonnet B"], ["85C / 90C", "88-93", "Bonnet C"], ["90D / 95D", "93-98", "Bonnet D"]];

const Table = ({ headers, rows }) => (
  <div className="overflow-x-auto border border-dore/20">
    <table className="w-full text-sm">
      <thead><tr className="bg-noir text-white">{headers.map((h, i) => <th key={i} className="px-4 py-3 text-left font-medium text-xs uppercase tracking-wider">{h}</th>)}</tr></thead>
      <tbody>{rows.map((r, i) => <tr key={i} className={i % 2 ? "bg-white" : "bg-creme"}>{r.map((c, j) => <td key={j} className="px-4 py-3 text-ardoise">{c}</td>)}</tr>)}</tbody>
    </table>
  </div>
);

export default function GuideTailles() {
  return (
    <div data-testid="guide-tailles-page">
      <div className="bg-noir text-center py-16 px-6 grain relative">
        <h1 className="font-display text-4xl md:text-6xl text-white relative">Guide des Tailles</h1>
        <p className="font-serif-el italic text-dore text-lg mt-2 relative">Trouvez la taille parfaite</p>
      </div>
      <div className="max-w-4xl mx-auto px-6 py-14 space-y-12">
        <div>
          <h2 className="font-display text-2xl text-encre mb-4">Vêtements (cm)</h2>
          <Table headers={["Taille", "FR", "Poitrine", "Taille", "Hanches"]} rows={CLOTHES} />
        </div>
        <div>
          <h2 className="font-display text-2xl text-encre mb-4">Lingerie & Soutien-gorge</h2>
          <Table headers={["Taille", "Tour de dos (cm)", "Bonnet"]} rows={BRA} />
        </div>
        <div>
          <h2 className="font-display text-2xl text-encre mb-4">Maillots de bain</h2>
          <p className="text-ardoise text-sm">Nos maillots suivent les tailles vêtements standards (S à XL). En cas d'hésitation entre deux tailles, nous recommandons de prendre la taille au-dessus pour un confort optimal.</p>
        </div>
        <div className="bg-rose/30 p-8">
          <h3 className="font-display text-xl text-encre mb-3">Conseils pour bien mesurer</h3>
          <ul className="space-y-2 text-sm text-ardoise">
            <li><b>Poitrine :</b> mesurez à l'endroit le plus fort de la poitrine.</li>
            <li><b>Taille :</b> mesurez au creux de la taille, partie la plus fine.</li>
            <li><b>Hanches :</b> mesurez à l'endroit le plus large des hanches.</li>
            <li>Gardez le mètre bien horizontal et ni trop serré ni trop lâche.</li>
          </ul>
        </div>
        <div className="text-center">
          <a href={waLink("Bonjour ! J'ai besoin d'aide pour choisir ma taille.")} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-whatsapp text-white px-8 py-3.5 text-xs uppercase tracking-widest font-semibold hover:brightness-95 transition-all"><WhatsAppIcon size={15} /> Besoin d'aide pour votre taille ?</a>
        </div>
      </div>
    </div>
  );
}
